export default "__VITE_ASSET__BTkuEXaq__"